export const UK_ENGLISH_ONLY_INSTRUCTION = 'Respond in UK English only.';

export const withUkEnglish = prompt => {
    const text = String(prompt || '').trimEnd();
    if (text.toLowerCase().includes(UK_ENGLISH_ONLY_INSTRUCTION.toLowerCase())) {
        return text;
    }
    return `${text}\n\n${UK_ENGLISH_ONLY_INSTRUCTION}`;
};
